import type { Ref } from "vue";

import { computed } from "vue";

function useElementValue<
  Value extends boolean | number | string | null | undefined,
>(value: Ref<Value>) {
  return computed(() => {
    return typeof value.value === "boolean"
      ? String(value.value)
      : // tsgolint treats the generic Exclude as non-nullish, but Value can be null at runtime
        // oxlint-disable-next-line typescript/no-unnecessary-condition
        ((value.value as Exclude<Value, boolean>) ?? undefined);
  });
}

export { useElementValue };
